import { Fragment } from "react/jsx-runtime";
import { Href } from "../../../../Constants/Constants";
import { dynamicImage, Image } from "../../../../Utils";

const NotesList = () => {
  return (
    <Fragment>
      <div className="notes-list">
        <h6 className="mb-2 text-muted">Joshephin Water.10 Jan</h6>
        <div className="d-flex gap-3">
          <Image className="img-fluid" src={dynamicImage("file_icons/5.png")} alt="media-img" />
          <div className="flex-grow-1"><h4 className="mt-0">Joshephin Water</h4></div>
        </div>
        <h5 className="mb-2">Imporatnt project link</h5>
        <h6 className="mb-2">Please start testing task of your projects.</h6>
        <div className="forward-main">
          <a className="line fa fa-mail-forward" href={Href}>Forward</a>
        </div>
      </div>
      <div className="notes-list">
        <h6 className="mb-2 text-muted">Kristin Watson.10 Jan</h6>
        <h5 className="mb-2">Other project link</h5>
        <h6 className="mb-2">Commencement of Validation</h6>
        <div className="forward-main">
          <a className="line fa fa-mail-forward" href={Href}>Forward</a>
        </div>
      </div>
    </Fragment>
  );
};

export default NotesList;
